import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

interface LoadingScreenProps {
  message?: string;
}

/** Full-window loader shown before the shell mounts, so it carries the island. */
const LoadingScreen: React.FC<LoadingScreenProps> = ({ message }) => {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-live="polite"
      className="revy-ui flex h-screen w-screen flex-col items-center justify-center gap-4 bg-background text-foreground"
    >
      <Loader2
        className="size-10 animate-spin text-primary motion-reduce:animate-none"
        strokeWidth={1.8}
      />
      <p className="revy-cjk text-base leading-[1.6] text-muted-foreground">
        {message ?? t('common.loading')}
      </p>
    </div>
  );
};

export default LoadingScreen;
